export default [
  'CadastroFederalSemMascara',
  'CadastroFederal',
  'RazaoSocial',
  'ConsultadoEm',
  'NumeroParcela',
  'MesParcelaAtual',
  'DataPedido',
]
